import { Menu } from 'antd';
import styled from 'styled-components';

export const MenuStyled = styled(Menu)`
	margin: 0 auto;
	border-bottom: none;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: block;
	}
`;
